// extracted by mini-css-extract-plugin
export var avatarContainer = "_80-0";
export var avatarTypingWave = "_80-i";
export var gray = "_80-f";
export var green = "_80-c";
export var icon = "_80-9";
export var image = "_80-1";
export var lg = "_80-6";
export var md = "_80-5";
export var presenceDot = "_80-b";
export var red = "_80-d";
export var sm = "_80-4";
export var status = "_80-a";
export var typingDot = "_80-h";
export var typingPill = "_80-g";
export var xl = "_80-7";
export var xs = "_80-3";
export var xxl = "_80-8";
export var xxs = "_80-2";
export var yellow = "_80-e";